import React from 'react';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Breadcrum.css';


const Breadcrums = ({product}) => {

    const { t } = useTranslation();

    const categoryName = t(`category.${product.category}`);





    return (
        <nav className='breadcrum'>
            <Link to={`/${product.category}`}>{categoryName}</Link> &gt; {t(product.name)}
        </nav>
    )
}

export default Breadcrums;

// const {product} = props; комент тому що не перекладалося

// const categoryName =
//     product.category === "AdBlue" ? t("category.AdBlue") :
//         product.category === "MineralFertilizers" ? t("category.MineralFertilizers") :
//             t(product.category);
